import { environment } from "src/environments/environment";

type Category = 'Pay' | 'NonPay';
type WeekStart = 'sunday'

interface CategoryOptions {
    referenceWeekCategory?: Category;
    referenceDate?: Date;
    weekStartsOn?: WeekStart;
    timeZone?: string;
  }

  
 export function getCurrentDateStringAZ(): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Local",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
}

 
  export function getZonedYMD(date: Date, timeZone?: string) {
    const fmt = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
    const parts = fmt.formatToParts(date);
    const y = Number(parts.find(p => p.type === 'year')!.value);
    const m = Number(parts.find(p => p.type === 'month')!.value);
    const d = Number(parts.find(p => p.type === 'day')!.value);
    return { y, m, d };
  }

  export function startOfZonedDay(date: Date, timeZone?: string): Date {
    const { y, m, d } = getZonedYMD(date, timeZone);
    return new Date(Date.UTC(y, m - 1, d, 0, 0, 0, 0));
  }

  export function getZonedDayIndex(date: Date, timeZone?: string): number {
    const name = new Intl.DateTimeFormat('en-US', {
      timeZone,
      weekday: 'short',
    }).format(date); // "Sun", "Mon", ...
    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(name);
  }

  export function startOfWeek(date: Date, weekStartsOn: WeekStart, timeZone?: string): Date {
    const midnight = startOfZonedDay(date, timeZone);
    const dayIdx = getZonedDayIndex(date, timeZone); // 0..6 with Sunday=0

    const offset = weekStartsOn === 'sunday'
      ? dayIdx
      : (dayIdx + 6) % 7; // shift so Monday=0 ... Sunday=6

    return new Date(midnight.getTime() - offset * 24 * 60 * 60 * 1000);
  }

  export function weeksBetween(aWeekStart: Date, bWeekStart: Date): number {
    const diffMs = bWeekStart.getTime() - aWeekStart.getTime();
    // 7 * 24 * 60 * 60 * 1000
    return Math.floor(diffMs / 604800000);
  }
  export function parseDate_MMDDYYYY(dateStr: string): Date {
    const [month, day, year] = dateStr.split("/").map(Number);
    return new Date(year, month - 1, day);
  }

  export function getWeeklyAlternatingCategory(
    targetDate: Date,
    options: CategoryOptions = {}
  ): Category {
    const {
      referenceWeekCategory = 'Pay',
      referenceDate = parseDate_MMDDYYYY(environment.PayWeek),
      weekStartsOn = 'sunday',
      timeZone,
    } = options;


    const refWeekStart = startOfWeek(referenceDate, weekStartsOn, timeZone);
    const targetWeekStart = startOfWeek(targetDate, weekStartsOn, timeZone);
    const deltaWeeks = weeksBetween(refWeekStart, targetWeekStart);
    const isEven = deltaWeeks % 2 === 0;
    if (isEven) return referenceWeekCategory;
    return referenceWeekCategory === 'Pay' ? 'NonPay' : 'Pay';
  }

